import { PoGrid } from '@/components/grid/PoGrid';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { GridOptions, RowDoubleClickedEvent, ValueGetterParams } from 'ag-grid-community';
import ErrorLoadingDataAlert from '@/components/feedback/ErrorLoadingDataAlert';
import { ColDefOrGroup } from '@/lib/ag-grid/types';
import { EventModel, EventModelFieldNames } from '@/modules/events/types/EventModel';
import { RelativeDateCellRenderer } from '@/components/grid/cells/RelativeDateCellRenderer';
import { useTranslation } from '@/lib';

interface LocationEventsGridProps {
  data?: EventModel[];
  isError: boolean;
}

export const LocationEventsGrid: FunctionComponent<LocationEventsGridProps> = ({ data, isError }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!data) {
    return <div>{t('no_data')}</div>;
  }

  const customGridOptions: GridOptions<EventModel> = {
    onRowDoubleClicked(event: RowDoubleClickedEvent<EventModel, unknown>) {
      navigate(`/app/events/${event.data?.id}`);
    },
  };

  const columns: ColDefOrGroup<EventModel>[] = [
    {
      field: EventModelFieldNames.AssetCode,
      headerName: t('event.asset_code'),
      sortable: false,
    },
    {
      field: EventModelFieldNames.OccurredAt,
      cellRenderer: RelativeDateCellRenderer,
      headerName: t('event.occurred_at'),
      sortable: false,
    },
    {
      headerName: t('event.type.title'),
      valueGetter: (params: ValueGetterParams<EventModel>) => {
        return t(`event.type.${params.data?.type}`);
      },
      flex: 1,
      sortable: false,
    },
    {
      headerName: 'Source',
      valueGetter: (params: ValueGetterParams<EventModel>) => {
        return t(`enums.event_source.${params.data?.eventSource}`);
      },
      sortable: false,
    },
  ];

  return (
    <div className="flex h-full flex-1 grow flex-col">
      {isError ? <ErrorLoadingDataAlert /> : <PoGrid isLoading={false} colDefs={columns} rowData={data} gridOptions={customGridOptions} />}
    </div>
  );
};
